import React, {Component} from 'react'
import {Button} from "react-bootstrap";
import LoginService from "../../../../admin/loginComponents/LoginService";
import {NotificationManager} from "react-notifications";

export default class ZnizkaUstawowa extends Component {

    constructor(props) {
        super(props);

        this.state = {
            zdjecieInvalid: false,
            zdjecie: [],
            zdjecieShow: [],
            zdjecieShowDodane: [],
            pokazDate: false,
            date: this.props.nrDokWaznyDo,
            nrDok: this.props.nrDok,
            dataUrodzenia: this.props.dataUrodzenia,
            typ: this.props.typ.value
        };

        this.onChangeNrDok = this.onChangeNrDok.bind(this);
        this.onChangeDate = this.onChangeDate.bind(this)
        this.onChangeDataUrodzenia = this.onChangeDataUrodzenia.bind(this)
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.typ !== this.props.typ) {
            if (this.props.typ.value === 'SM' || this.props.typ.value === 'KM' || this.props.typ.value === 'DM') {
                this.setState({pokazDate: true})
            } else {
                this.setState({pokazDate: false})
            }
        }
    }

    componentDidMount() {
        const typ = this.props.typ.value

        if (this.props.zakupKarty) {
            LoginService.getKlient(JSON.parse(sessionStorage.getItem('loggedIn')).idKl, JSON.parse(sessionStorage.getItem('loggedIn')).login, JSON.parse(sessionStorage.getItem('loggedIn')).pass)
                .then(function (response) {
                    let res = response.data;
                    this.setState({
                        nrDok: res.nrDok,
                        date: res.nrDokWaznyDo,
                        nrDokSkan: res.nrDokSkan,
                        dataUrodzenia: res.dataUrodzenia
                        // zdjecieShowDodane: zdjecie,
                    })
                }.bind(this)).catch(err => {
                console.log(err);
            });
        }
        if (typ === 'SM' || typ === 'KM' || typ === 'DM') {
            this.setState({pokazDate: true})
        }
    }

    onChangeNrDok(e) {
        this.setState({nrDok: e.target.value})
    }

    onChangeDate(e) {
        this.setState({date: e.target.value})
    }

    onChangeDataUrodzenia(e) {
        this.setState({dataUrodzenia: e.target.value})
    }

    wyslijUlga() {
        if ((this.props.typ.value === 'SM' || this.props.typ.value === 'KM' || this.props.typ.value === 'DM') && (this.state.dataUrodzenia === '' || this.state.dataUrodzenia === null)) {
            NotificationManager.error("", "Uzupełnij datę urodzenia. ", 5000)
        } else {
            if (this.state.nrDok === '' || this.state.nrDok === null || this.state.date === '' || this.state.date === null) {
                NotificationManager.error("", "Uzupełnij dane dokumentu uprawniającego do zniżki. ", 5000)
            } else {
                LoginService.putRegister(JSON.parse(sessionStorage.getItem('loggedIn')).idKl,
                    JSON.parse(sessionStorage.getItem('loggedIn')).login,
                    JSON.parse(sessionStorage.getItem('loggedIn')).pass,
                    JSON.parse(sessionStorage.getItem('loggedIn')).imie,
                    JSON.parse(sessionStorage.getItem('loggedIn')).nazwisko,
                    JSON.parse(sessionStorage.getItem('loggedIn')).pesel,
                    this.state.nrDok,
                    this.state.date,
                    this.state.dataUrodzenia,
                    JSON.parse(sessionStorage.getItem('loggedIn')).miejscowosc,
                    JSON.parse(sessionStorage.getItem('loggedIn')).kodPoczt,
                    JSON.parse(sessionStorage.getItem('loggedIn')).ulica,
                    JSON.parse(sessionStorage.getItem('loggedIn')).nrDomu,
                    JSON.parse(sessionStorage.getItem('loggedIn')).nrMieszk,
                    JSON.parse(sessionStorage.getItem('loggedIn')).nrTel,
                    // this.state.zdjecieShow
                )
                    .then(function (response) {
                        sessionStorage.setItem('loggedIn', JSON.stringify({
                            idKl: JSON.parse(sessionStorage.getItem('loggedIn')).idKl,
                            imie: JSON.parse(sessionStorage.getItem('loggedIn')).imie,
                            nazwisko: JSON.parse(sessionStorage.getItem('loggedIn')).nazwisko,
                            miejscowosc: JSON.parse(sessionStorage.getItem('loggedIn')).miejscowosc,
                            kodPoczt: JSON.parse(sessionStorage.getItem('loggedIn')).kodPoczt,
                            nrDok: this.state.nrDok,
                            dataUrodzenia: this.state.dataUrodzenia,
                            nrDokWaznyDo: this.state.date,
                            nrDomu: JSON.parse(sessionStorage.getItem('loggedIn')).nrDomu,
                            nrMieszk: JSON.parse(sessionStorage.getItem('loggedIn')).nrMieszk,
                            nrTel: JSON.parse(sessionStorage.getItem('loggedIn')).nrTel,
                            pesel: JSON.parse(sessionStorage.getItem('loggedIn')).pesel,
                            ulica: JSON.parse(sessionStorage.getItem('loggedIn')).ulica,
                            pliki: JSON.parse(sessionStorage.getItem('loggedIn')).pliki,
                            login: JSON.parse(sessionStorage.getItem('loggedIn')).login,
                            pass: JSON.parse(sessionStorage.getItem('loggedIn')).pass
                        }));
                        if (sessionStorage.getItem('link') !== null) {
                            window.location.replace(sessionStorage.getItem('link'));
                            sessionStorage.removeItem('link')
                        } else {
                            if (window.location.href.indexOf("dane") > -1) {
                                NotificationManager.success("", "Dane zostały zaktualizowane ", 5000)

                            } else {
                                window.location.reload()
                            }
                        }
                    }.bind(this)).catch(err => {
                    console.log(err);
                });
                console.log({
                    nr: this.state.nrDok,
                    date: this.state.date,
                    dataUrodzenia: this.state.dataUrodzenia,
                    zdjecia: this.state.zdjecieShow
                })
            }
        }
    }

    render() {

        const {pokazDate} = this.state

        return <div>

            <div className="row">
                {pokazDate ? <div className="col-sm-4" style={{fontSize: '0.875rem', textAlign: 'justify'}}>
                    <div className="inputLabel" style={{textAlign: 'left', paddingTop: 15}}>Data urodzenia<font
                        color="red">*</font>:
                        <input type="date" className={"clearRemove"} value={this.state.dataUrodzenia} clearable={false}
                               onChange={this.onChangeDataUrodzenia.bind(this)}
                               className="form-control"/>
                    </div>
                </div> : null}
                <div className={pokazDate ? "col-sm-4" : "col-sm-6"}>
                    <div className="inputLabel" style={{textAlign: 'left', paddingTop: 15}}>Numer dokumentu<font
                        color="red">*</font>:
                    </div>
                    <input type="text" value={this.state.nrDok} onChange={this.onChangeNrDok.bind(this)}
                           className="form-control"/>
                </div>
                <div className={pokazDate ? "col-sm-4" : "col-sm-6"}
                     style={{fontSize: '0.875rem', textAlign: 'justify'}}>
                    <div className="inputLabel" style={{textAlign: 'left', paddingTop: 15}}>Data ważności<font
                        color="red">*</font>:
                        <input type="date" className={"clearRemove"} value={this.state.date} clearable={false}
                               onChange={this.onChangeDate.bind(this)}
                               className="form-control"/>
                    </div>

                </div>
            </div>
            <div className="row" style={{paddingTop: 10}}>
                <div className="col-sm-12 text-right">
                    <Button bsStyle={'success'}
                            onClick={() => this.wyslijUlga()}>Zapisz</Button>
                </div>
            </div>
        </div>

    }
}




// WEBPACK FOOTER //
// ./src/components/konto/panel/panelComponents/daneComponents/ZnizkaUstawowa.js